import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import Icon from '@hixme-ui/icon'
import Container from '@hixme-ui/container'
import cx from 'helpers/cx'

import classes from './AppLayout.module.scss'

const AppSidebar = ({ children }) => (
  <div className={classes.sidebarInner}>
    <Container role="navigation">{children}</Container>
  </div>
)

AppSidebar.propTypes = {
  children: PropTypes.node,
}

AppSidebar.defaultProps = {
  children: null,
}

const AppHeader = ({ children, fixed, toggleSidebar, open }) => (
  <div
    className={cx(
      classes.header,
      fixed && classes.headerFixed,
      fixed && open && classes.headerSidebarOpen
    )}
  >
    <button
      type="button"
      className={classes.menuButton}
      aria-label={open ? 'Close menu' : 'Open menu'}
      aria-expanded={open}
      onClick={toggleSidebar}
    >
      <Icon menu light size={1.6} />
    </button>
    <div className={classes.headerContent}>{children}</div>
  </div>
)

AppHeader.propTypes = {
  children: PropTypes.node,
  fixed: PropTypes.bool,
  toggleSidebar: PropTypes.func,
  open: PropTypes.bool,
}

AppHeader.defaultProps = {
  children: null,
  fixed: true,
  toggleSidebar: () => {},
  open: false,
}

class AppLayout extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    HeaderComponent: PropTypes.func,
    SidebarComponent: PropTypes.func,
    open: PropTypes.bool,
    sidebarWidth: PropTypes.string,
    fixed: PropTypes.bool,
    contentBackgroundColor: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
  }

  static defaultProps = {
    open: false,
    HeaderComponent: () => null,
    SidebarComponent: () => null,
    sidebarWidth: '225px',
    fixed: false,
    contentBackgroundColor: '#F6F9FC',
  }

  state = { open: this.props.open }

  componentDidUpdate(prevProps) {
    // Layout stays mounted across child routes; close overlay after sidebar navigation.
    if (this.props.location !== prevProps.location && this.state.open) {
      this.setState({ open: false })
    }
  }

  render() {
    const {
      HeaderComponent,
      SidebarComponent,
      children,
      fixed,
      sidebarWidth,
      contentBackgroundColor,
    } = this.props
    const { open } = this.state

    const toggleSidebar = () => {
      this.setState((prevState) => ({
        open: !prevState.open,
      }))
    }

    const layoutVars = {
      '--app-sidebar-width': sidebarWidth,
      '--app-content-bg': contentBackgroundColor,
    }

    return (
      <div className={classes.root} style={layoutVars}>
        <div className={cx(classes.sidebar, open && classes.sidebarOpen)}>
          <AppSidebar>
            <SidebarComponent />
          </AppSidebar>
        </div>
        <button
          type="button"
          className={cx(classes.backdrop, open && classes.backdropOpen)}
          aria-label="Close menu"
          tabIndex={open ? 0 : -1}
          onClick={() => {
            if (open) {
              toggleSidebar()
            }
          }}
        />
        <div className={cx(classes.main, open && classes.mainOpen)}>
          <AppHeader fixed={fixed} toggleSidebar={toggleSidebar} open={open}>
            <HeaderComponent />
          </AppHeader>
          <div className={cx(classes.content, fixed && classes.contentFixed)}>{children}</div>
        </div>
      </div>
    )
  }
}

AppLayout.displayName = 'AppLayout'

export default withRouter(AppLayout)
